import TemplateView from "../TemplateView"
import messageResource from "../messageResource";
import TaskStatusButton from "../controls/task/TaskStatusButton";
import CompletedTaskStatusMenu from "../controls/task/CompletedTaskStatusMenu";
import {selectFirstStatusByType} from '../workflowStatus/selectors'
import {unsafe_selectWithState} from '../redux/utils'
import {WorkflowStatusType} from "../workflowStatus/constants";
import {taskNameLower} from '../util/pluralizeUtils'

export default class ArchiveDialog extends TemplateView {
    constructor($container, typeTitle) {
        super($container);
        this.typeTitle = typeTitle;

        this.state = {
            openTaskNumber: 0,
            statusId: unsafe_selectWithState((state) => selectFirstStatusByType(state, WorkflowStatusType.COMPLETED).id),
        }

        this.onStatePropertyChanged("openTaskNumber", () => this.updateMessages());
        this.onStatePropertyChanged("statusId", () => this.taskStatusButton.setState({statusId: this.state.statusId}));
    }

    templateHtml() {
        return "<div class='archiveDialog'>" +
               "  <div class='title'><%-title%></div>" +
               "  <div class='description'></div>" +
               "  <div class='statusSelector'></div>" +
               "  <div class='buttonsContainer'>" +
               "    <div class='archive button'><%=archive%></div>" +
               "    <div class='cancel button'><%=cancel%></div>" +
               "  </div> " +
               "</div>";
    }

    afterRender() {
        this.$archiveButton = this.find(".archive");
        this.$cancelButton = this.find(".cancel");
        this.$statusSelector = this.find(".statusSelector");
        this.taskStatusButton = new TaskStatusButton({
            editable: true,
            taskStatusMenu: new CompletedTaskStatusMenu(this.getEl()).init(),
            showStatusTypePrefix: true,
            positionParams: {
                within: this.$el,
                collision: 'fit',
            },
            onStatusChangedCb: (statusId) => this.setState({
                statusId
            })
        }).init(this.$statusSelector)

        this.taskStatusButton.setState({statusId: this.state.statusId});
        this.$description = this.find(".description");
        this.$archiveButton.click(() => this.trigger("archived", this.getSelectedStatusId()));
        this.$cancelButton.click(() => this.trigger("cancel", []));
    }

    templateModel() {
        return {
            title: messageResource.getMessage("task.list.panel.archive_dialog.title", [this.typeTitle])
        }
    }

    getSelectedStatusId() {
        return this.taskStatusButton.state.statusId;
    }

    updateMessages() {
        this.$description.text(messageResource.getMessage("task.list.panel.archive_dialog.description", [
            this.state.openTaskNumber,
            taskNameLower(this.state.openTaskNumber)
        ]))
    }

    messageKeys() {
        return {
            archive: "common.archive",
            cancel: "common.cancel"
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/ArchiveDialog.js